import deepmerge from 'core/libs/deepmerge';

import { viewportBreakpoints, MOBILE_BIG } from 'core/components/breakpoint/viewport-values';


export default function stylesAtomsFactoryMobile(theme, mobileTheme = {}) {
  const {
    colors,
    fonts,
  } = theme;

  const icons = {
    ...theme.icons,
    ...mobileTheme.icons,
  };

  const texts = deepmerge.all([
    theme.texts || {},
    {
      title1: {
        font: `bold 40px/48px ${fonts.display}`,
      },

      title2: {
        font: `bold 26px/32px ${fonts.display}`,
      },

      title3: {
        font: `bold 20px/24px ${fonts.display}`,
      },

      title4: {
        font: `bold 16px/19px ${fonts.display}`,
      },

      title5: {
        font: `bold 14px/16px ${fonts.text}`,
      },

      title6: {
        font: `bold 14px/16px ${fonts.text}`,
      },

      headline: {
        font: `bold 26px/32px ${fonts.display}`,
      },

      body: {
        font: `16px/22px ${fonts.text}`,
      },

      bodySmall: {
        font: `12px/14px ${fonts.text}`,
      },

      lead: {
        font: `bold 14px/20px ${fonts.display}`,
      },

      incut: {
        font: `italic 16px/20px ${fonts.text}`,
      },

      caption1: {
        font: `12px/14px ${fonts.display}`,
      },

      caption2: {
        font: `12px/14px ${fonts.display}`,
      },

      caption3: {
        font: `12px/14px ${fonts.display}`,
      },

      caption4: {
        font: `bold 12px/14px ${fonts.display}`,
      },

      caption5: {
        font: `bold 14px/16px ${fonts.display}`,
      },

      decor1: {
        font: `16px/20px ${fonts.nuance}`,
      },

      get tableCell() {
        return this.body;
      },
    },
    mobileTheme.texts || {},
  ]);

  const vikontReadMore = {
    title: {
      marginBottom: '10px',
    },
    drum: {
      itemWidth: 200,
      spaceBetween: 15,
      sideIndent: 15,
    },
    feed: {
      interitemSpacing: 15,
    },
  };

  const vikontSideBySide = {
    image: {
      interimageSpacing: 0,
      useVerticalImages: true,
    },
  };

  const vikontImage = {
    maxWidth: 750,
    maxHeight: 500,
  };

  const vikontOpinion = {
    opinion: {
      maxWidth: '100%',
      width: '100%',
      padding: '4px 0 12px 0',
    },
    job: {
      font: `400 12px/20px ${fonts.text}`,
    },
    name: {
      font: `700 16px/28px ${fonts.display}`,
      marginBottom: '0',
    },
    authorImage: {
      size: 42,
      marginRight: '16px',
    },
    body: {
      marginBottom: '16px',
      paddingLeft: '20px',
    },
    bodyBefore: {
      width: '8px',
    },
  };

  const vikontIncut = {
    padding: '16px 26px',
    font: texts.incut.font,
  };

  const scooter = {
    padding: '0 15px',
    menuLink: {
      ...texts.caption2,
    },
    logo: {
      width: '200px',
    },
    commercial: {
      border: `1px solid ${colors.divider}`,
    },
    social: {
      margin: 0,
    },
  };

  const socializator = {
    borderRadius: 20,
    buttonHeight: 40,
    iconSize: 18,
    iconsGap: 10,
  };

  const layout = deepmerge.all([
    theme.layout || {},
    {
      maxWidth: viewportBreakpoints[MOBILE_BIG],
      minWidth: '320px',
      boxShadow: 'none',
      indents: {
        top: 15,
        right: 15,
        bottom: 15,
        left: 15,
      },
    },
    mobileTheme.layout || {},
  ]);

  const notes = {
    font: texts.body.font,
  };

  const story = {
    slide: {
      width: 140,
      spaceBetween: 5,
    },
  };

  const storyCard = {
    headline: {
      font: `bold 12px/15px ${fonts.display}`,
    },
  };

  const shapkaLink = {
    padding: '10px 0',
  };

  const shapkaDropdown = {
    link: shapkaLink,
    padding: '0px',
    fullwidth: true,
    trigger: 'click',
    boxShadow: 'none',
    borderRadius: '0px',
  };

  const shapka = {
    hideLogoInModal: false,

    link: shapkaLink,

    dropdown: {
      ...shapkaDropdown,
      premiumTopic: {
        ...shapkaDropdown,
        background: colors.content,
      },
    },
    height: 60,

    padding: '0 15px 0 15px',
    shadow: '0 0 14px 0 rgba(0, 0, 0, .2)',

    menu: {
      hideBouesque: false,
      itemDivider: `1px solid ${colors.divider}`,
      navMargin: '20px 0 0',
    },
  };

  const captionCredits = {
    padding: '0 20px',
    credits: {
      margin: '5px 0 0',
    },
  };

  const vikontSpoiler = {
    block: {
      outerIndent: '17px 0 21px',
      innerIndent: '6px 0',
    },
    title: {
      font: `700 20px/30px ${fonts.display}`,
    },
  };

  const vikontVerdict = {
    title: {
      font: `500 18px/21px ${fonts.display}`,
      color: colors.content,
    },
    text: {
      font: `400 15px/23px ${fonts.display}`,
    },
  };

  const commentButton = {
    size: 'small',
  };

  const topicFooter = {
    block: {
      spacing: 20,
    },
  };

  const topicPages = {
    text: texts.caption4,
  };

  const commentsPreview = {
    headline: {
      font: `bold 26px/32px ${fonts.display}`,
    },
    name: {
      font: `bold 14px/18px ${fonts.display}`,
    },
  };

  const topicContent = {
    list: {
      top: 32,
      bottom: 24,
    },
    ads: {
      bottom: 24,
    },
    image: {
      bottom: 28,
    },
  };

  const errorPageParams = {
    title: {
      font: `bold 22px/29px ${fonts.display}`,
    },
    subtitle: {
      font: `14px/16px ${fonts.text}`,
    },
    padding: '40px 10px 50px',
    popular: {
      title: {
        font: `bold 18px/24px ${fonts.display}`,
        color: colors.primary,
      },
    },
  };

  const smartTeaser = {
    carRelease: {
      title: {
        font: `700 18px/20px ${fonts.display}`,
      },
      caption: {
        font: `300 12px/14px ${fonts.text}`,
      },
      info: {
        font: `500 13px/18px ${fonts.text}`,
      },
    },
    gameCompare: {
      headline: {
        font: `700 18px/22px ${fonts.display}`,
      },
      imageMaxWidth: 550,
      progressType: 1,
    },
  };

  const expert = {
    info: {
      marginLeft: '20px',
    },
    name: {
      idle: {
        font: `600 14px/21px ${fonts.display}`,
      },
      hover: {
        font: `600 14px/21px ${fonts.display}`,
      },
    },
    jobTitle: {
      font: `300 12px/17px ${fonts.display}`,
    },
    label: {
      font: `700 8px/1 ${fonts.display}`,
    },
    avatar: {
      width: 48,
    },
  };

  const topicHeaderTexts = {
    title: texts.title1,
    subtitle: texts.title2,
    lead: {
      top: 10,
      ...texts.lead,
    },
    list: {
      top: 28,
    },
    marginBottom: 16,
    premiumTopic: {
      subtitle: {
        font: `600 16px/20px ${fonts.text}`,
      },
      title: {
        font: `800 22px/28px ${fonts.text}`,
      },
    },
  };

  const gameCompare = {
    compare: {
      progressType: 2,
      draw: {
        font: `700 24px/31px ${fonts.display}`,
      },
      text: {
        font: `400 12px/18px ${fonts.text}`,
      },
    },
    leaderBoard: {
      header: {
        font: `300 11px/16px ${fonts.display}`,
      },
      count: {
        font: `700 14px/20px ${fonts.display}`,
      },
      modalWindow: {
        color: colors.content,
      },
      caption: `700 15px/22px ${fonts.text}`,
      progressbar: {
        height: '1px',
        progressHeight: '3px',
      },
      pairCompare: {
        margin: '0 0 40px',
      },
    },
    announce: {
      font: `18px/25px ${fonts.text}`,
    },
    tooltip: {
      scheme: {
        titleFont: `400 18px/30px ${fonts.text}`,
        textFont: `300 16px/23px ${fonts.text}`,
      },
    },
    winner: {
      viewBox: '0 0 380 500',
      imageTop: '100px',
    },
    concidences: {
      font: `300 13px/19px  ${fonts.text}`,
    },
  };

  const reactionsEmojiBar = {
    const: {
      padding: '20px 14px',
    },

    controls: {
      interitemSpacing: 8,
    },
  };

  const cookiesBanner = {
    bannerOffsetBottom: '8px',
  };

  const about = {
    headline: {
      font: `bold 26px/32px ${fonts.text}`,
    },
    title2: {
      font: `bold 26px/32px ${fonts.text}`,
    },
    padding: '0 15px',
  };

  const controls = deepmerge.all([
    theme.controls || {},
    {
      vikontReadMore,
      scooter,
      socializator,
      notes,
      story,
      storyCard,
      shapka,
      captionCredits,
      expert,
      topicFooter,
      topicPages,
      commentsPreview,
      vikontSpoiler,
      vikontVerdict,
      vikontOpinion,
      vikontSideBySide,
      vikontImage,
      vikontIncut,
      topicHeaderTexts,
      topicContent,
      smartTeaser,
      gameCompare,
      reactionsEmojiBar,
      cookiesBanner,
      about,
      commentButton,
    },
    mobileTheme.controls || {},
  ]);

  const pages = deepmerge.all([
    theme.pages || {},
    {
      error: errorPageParams,
      notFound: errorPageParams,
      sentryFallback: errorPageParams,
      development: errorPageParams,
      offline: errorPageParams,
    },
    mobileTheme.pages || {},
  ]);

  const ads = deepmerge.all([
    theme.ads || {},
    mobileTheme.ads || {},
  ]);

  return {
    ...theme,
    ...mobileTheme,
    texts,
    controls,
    pages,
    icons,
    ads,
    layout,
  };
}
